<template>
  <div class="accounts-page">
    <!-- <PreloaderPage /> -->
    <BannerPages
      :title="'accounts.banner.title'"
      :descriptions="[
        $t('accounts.banner.description-1')
      ]"
      :img="'/images/accounts/Accounts-Img1.png'"
      mainImageWidthDesk="576"
      mainImageHeightDesk="526"
      alt="Tradeview Head of Trading and Chief Officer"
      :buttons="[
        {
          type: 'external',
          href: getExternalUrl('/register/1/live-account'),
          class: 'primary-button-medium',
          text: 'accounts.banner.link1' 
        }
      ]"
    />

    <LazyYourOpportunity :style="degrade"/>

    <div class="header-text">
      <LazyTabsAccounts
        :tabs="tabs"
        :categories="categories"
        :cardsForex="cardsForex"
        :titleCardsStocks="titleCardsStocks"
        :cardsStocks="cardStocks"
        :cardsFutures="cardsFutures"
      />
    </div>

    <LazyToStart :style="degrade2"/>

    <client-only>
      <LazyInvestment
        :label="'accounts.ready'"
        :buttonConfigs="[
          {
            type: 'external',
            href: getExternalUrl('/register/1/live-account'),
            class: 'primary-button-medium',
            textKey: 'investment.link'
          }
        ]"
      />
    </client-only>
  </div>
</template>

<!-- Config just SEO -->
<script setup>
import LazyYourOpportunity from "~/components/accounts/YourOpportunity";
import LazyTabsAccounts from "~/components/accounts/TabsAccounts";
import LazyToStart from "~/components/accounts/ToStart.vue";
// import PreloaderPage from "~/components/PreloaderPage.vue";
import { useI18n } from "vue-i18n";
import { useExternalUrl } from '@/composables/useExternalUrl';
import { useImage } from '#imports'; 

const { getExternalUrl } = useExternalUrl();
const { $regulationsVar } = useNuxtApp();
const { t, locale } = useI18n();

const regulation = ref($regulationsVar.getRegulation(locale.value));
const nuxtImg = useImage();

const title = t("seo.accounts.title");
const description = t("seo.accounts.description");
const imgSeo = 'https://tradeview.eu/images/seo/13Accounts.jpg'

useSeoMeta({
  title: title,
  ogTitle: title,
  twitterTitle: title,
  description: description,
  ogDescription: description,
  twitterDescription: description,
  ogImage: imgSeo,
  twitterImage: imgSeo
});

const degradadeImageUrl = '/images/accounts/Accounts-Gradient.avif';
const degradadeImageUrl2 = '/images/accounts/Accounts-Gradient2.avif';

const optimizedDegrade = nuxtImg(degradadeImageUrl, {
  quality: 50,
  format: 'avif',
});
const optimizedDegrade2 = nuxtImg(degradadeImageUrl2, {
  quality: 50,
  format: 'avif',
});

const degrade = computed(() => {
  return {
    '--degrade': `url('${optimizedDegrade}')`,
  };
});

const degrade2 = computed(() => {
  return {
    '--degrade2': `url('${optimizedDegrade2}')`,
  };
});

let tabs = ref([
  { value: "forex", label: "trading.buildPortafolio.forexT" },
  { value: "stocks", label: "trading.buildPortafolio.stocksT" },
  /* { value: "futures", label: "trading.buildPortafolio.futuresT" }, */
]);

let categories = ref({
  forex: [
    {
      title: "accounts.tabsAccounts.forex.titleForexSeccion",
      description: "accounts.tabsAccounts.forex.descForexSeccion",
      text: {
        title: "accounts.tabsAccounts.forex.details.titleDetails",
        desc: "accounts.tabsAccounts.forex.details.descDetails",
      },
      details: [
        {
          icon: "school",
          title: "accounts.tabsAccounts.forex.details.item1Title",
          description: "accounts.tabsAccounts.forex.details.item1Desc",
        },
        {
          icon: "emoji_objects",
          title: "accounts.tabsAccounts.forex.details.item2Title",
          description: "accounts.tabsAccounts.forex.details.item2Desc",
        },
        {
          icon: "encrypted",
          title: "accounts.tabsAccounts.forex.details.item3Title",
          description: "accounts.tabsAccounts.forex.details.item3Desc",
        },
        {
          icon: "page_info",
          title: "accounts.tabsAccounts.forex.details.item4Title",
          description: "accounts.tabsAccounts.forex.details.item4Desc",
        },
        {
          icon: "trending_down",
          title: "accounts.tabsAccounts.forex.details.item5Title",
          description: "accounts.tabsAccounts.forex.details.item5Desc",
        },
      ],
    },
  ],
  stocks: [
    {
      title: "accounts.tabsAccounts.stocks.titleForexSeccion",
      /* description: "accounts.tabsAccounts.stocks.descForexSeccion", */
      description: "",
      text: {
        title: "accounts.tabsAccounts.stocks.details.titleDetails",
        desc: "accounts.tabsAccounts.stocks.details.descDetails",
      },
      details: [
        {
          icon: "school",
          title: "accounts.tabsAccounts.stocks.details.item1Title",
          description: "accounts.tabsAccounts.stocks.details.item1Desc",
        },
        {
          icon: "emoji_objects",
          title: "accounts.tabsAccounts.stocks.details.item2Title",
          description: "accounts.tabsAccounts.stocks.details.item2Desc",
        },
        {
          icon: "encrypted",
          title: "accounts.tabsAccounts.stocks.details.item3Title",
          description: "accounts.tabsAccounts.stocks.details.item3Desc",
        },
        {
          icon: "page_info",
          title: "accounts.tabsAccounts.stocks.details.item4Title",
          description: "accounts.tabsAccounts.stocks.details.item4Desc",
        },
        {
          icon: "search",
          title: "accounts.tabsAccounts.stocks.details.item5Title",
          description: "accounts.tabsAccounts.stocks.details.item5Desc",
        },
        {
          icon: "info",
          title: "accounts.tabsAccounts.stocks.details.item6Title",
          description: "accounts.tabsAccounts.stocks.details.item6Desc",
        },
      ],
    },
  ],
  /* futures: [
    {
      title: "accounts.tabsAccounts.futures.titleForexSeccion",
      description: "accounts.tabsAccounts.futures.descForexSeccion",
      text: {
        title: "accounts.tabsAccounts.futures.details.titleDetails",
        desc: "accounts.tabsAccounts.futures.details.descDetails",
      },
      details: [
        {
          icon: "school",
          title: "accounts.tabsAccounts.futures.details.item1Title",
          description: "accounts.tabsAccounts.futures.details.item1Desc",
        },
        {
          icon: "check_circle",
          title: "accounts.tabsAccounts.futures.details.item2Title",
          description: "accounts.tabsAccounts.futures.details.item2Desc",
        },
        {
          icon: "page_info",
          title: "accounts.tabsAccounts.futures.details.item3Title",
          description: "accounts.tabsAccounts.futures.details.item3Desc",
        },
        {
          icon: "emoji_objects",
          title: "accounts.tabsAccounts.futures.details.item4Title",
          description: "accounts.tabsAccounts.futures.details.item4Desc",
        },
        {
          icon: "clarify",
          title: "accounts.tabsAccounts.futures.details.item5Title",
          description: "accounts.tabsAccounts.futures.details.item5Desc",
        },
      ],
    },
  ], */
});

let cardsForex = ref([
  {
    title: "accounts.tabsAccounts.forex.cards.card-1-Title",
    items: [
      { column1: "accounts.tabsAccounts.forex.cards.card-1-item1" },
      { column1: "accounts.tabsAccounts.forex.cards.card-1-item2" },
      { column1: "accounts.tabsAccounts.forex.cards.card-1-item3" },
      { column1: "accounts.tabsAccounts.forex.cards.card-1-item4" },
      /* { column1: "accounts.tabsAccounts.forex.cards.card-1-item5" }, */
    ],
  },
  {
    title: "accounts.tabsAccounts.forex.cards.card-2-Title",
    items: [
      /* { column1: "accounts.tabsAccounts.forex.cards.card-2-item1" }, */
      { column1: "accounts.tabsAccounts.forex.cards.card-2-item2" },
      { column1: "accounts.tabsAccounts.forex.cards.card-2-item3" },
      { column1: "accounts.tabsAccounts.forex.cards.card-2-item4" },
      /* { column1: "accounts.tabsAccounts.forex.cards.card-2-item5" }, */
    ],
  },
  /* {
    title: "accounts.tabsAccounts.forex.cards.card-3-Title",
    items: [
      { column1: "accounts.tabsAccounts.forex.cards.card-3-item1" },
      { column1: "accounts.tabsAccounts.forex.cards.card-3-item2" },
      { column1: "accounts.tabsAccounts.forex.cards.card-3-item3" },
      { column1: "accounts.tabsAccounts.forex.cards.card-3-item4" },
      { column1: "accounts.tabsAccounts.forex.cards.card-3-item5" },
    ],
  }, */
]);


let cardStocks = ref([
  {
    title: "accounts.tabsAccounts.stocks.cards.column4-title",
    items:[
      { column1: "accounts.tabsAccounts.stocks.cards.column4-it1" },
      {column1: "accounts.tabsAccounts.stocks.cards.column4-it3"}
    ]
  }
])

/* let titleCardsStocks = ref({
  title: [
    { text: "" },
    { text: "accounts.tabsAccounts.stocks.cards.column2-title" },
    { text: "accounts.tabsAccounts.stocks.cards.column3-title" },
    { text: "accounts.tabsAccounts.stocks.cards.column4-title" },
    { text: "accounts.tabsAccounts.stocks.cards.column5-title" },
    { text: "accounts.tabsAccounts.stocks.cards.column6-title" },
  ],
});

let cardsStocks = ref([
  {
    title: " ",
    items: [
      { column1: "accounts.tabsAccounts.stocks.cards.column1-it1" },
      { column1: "accounts.tabsAccounts.stocks.cards.column2-it1" },
      { column1: "accounts.tabsAccounts.stocks.cards.column3-it1" },
      { column1: "accounts.tabsAccounts.stocks.cards.column4-it1" },
      { column1: "accounts.tabsAccounts.stocks.cards.column5-it1" },
      { column1: "accounts.tabsAccounts.stocks.cards.column6-it1" },
    ],
  },
  {
    title: "accounts.tabsAccounts.stocks.cards.column2-title",
    items: [
      { column1: "accounts.tabsAccounts.stocks.cards.column1-it2" },
      { column1: "accounts.tabsAccounts.stocks.cards.column2-it2" },
      { column1: "accounts.tabsAccounts.stocks.cards.column3-it2" },
      { column1: "accounts.tabsAccounts.stocks.cards.column4-it2" },
      { column1: "accounts.tabsAccounts.stocks.cards.column5-it2" },
      { column1: "accounts.tabsAccounts.stocks.cards.column6-it2" },
    ],
  },
  {
    title: "accounts.tabsAccounts.stocks.cards.column3-title",
    items: [
      { column1: "accounts.tabsAccounts.stocks.cards.column1-it3" },
      { column1: "accounts.tabsAccounts.stocks.cards.column2-it3" },
      { column1: "accounts.tabsAccounts.stocks.cards.column3-it3" },
      { column1: "accounts.tabsAccounts.stocks.cards.column4-it3" },
      { column1: "accounts.tabsAccounts.stocks.cards.column5-it3" },
      { column1: "accounts.tabsAccounts.stocks.cards.column6-it3" },
    ],
  },
]); */

let cardsFutures = ref([
  {
    title: "accounts.tabsAccounts.futures.cards.card-1-Title",
    items: [
      { column1: "accounts.tabsAccounts.futures.cards.card-1-item1" },
      { column1: "accounts.tabsAccounts.futures.cards.card-1-item2" },
    ],
  },
  {
    title: "accounts.tabsAccounts.futures.cards.card-2-Title",
    items: [
      { column1: "accounts.tabsAccounts.futures.cards.card-2-item1" },
      { column1: "accounts.tabsAccounts.futures.cards.card-2-item2" },
      { column1: "accounts.tabsAccounts.futures.cards.card-2-item3" },
    ],
  },
]);
</script>
